import { render, staticRenderFns } from "./DetailsEdit.vue?vue&type=template&id=2f567ba1&"
import script from "./DetailsEdit.vue?vue&type=script&lang=js&"
export * from "./DetailsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports